import { api } from '../functions/api';
import { ApiTransaction } from './types/ApiTransaction';
import { ApiPath } from '../api/ApiPath';
import { Transaction } from './types/Transaction';

export const getTransactions = (signal: AbortSignal) =>
  api<ApiTransaction[]>({
    url: ApiPath.Transactions,
    signal,
  }).then((transactions) => transactions.map((transaction) => new Transaction(transaction)));
